import { render, staticRenderFns } from "./damageModal.vue?vue&type=template&id=c5a33f66&scoped=true&"
import script from "./damageModal.vue?vue&type=script&lang=js&"
export * from "./damageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a33f66",
  null
  
)

export default component.exports